<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i
          class="material-icons"
          id="menu-toggle"
          @click="isSidebar =  !isSidebar"
          style="cursor:pointer"
          >view_headline</i
        >
        <app-navbar></app-navbar>
        <div class="mt46">
          <DashboardView  />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardView from "../../commonPages/NewDashbord"
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";


export default {
  data: () => ({
    isSidebar: false,

  }),

  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar,
     DashboardView
  },

};
</script>

<style scoped>

.myNavbar {
  color: rgb(255, 255, 255);
}
.mt46 {
  margin-top: 46px !important;
}

@media (max-width: 768px) {

}
</style>
